import styled from '@emotion/styled';

export let Wrapper = styled.div`
  margin: 0 20px;
  display: flex;
  align-items: center;
  width: 100%;
`;
